"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceRoutePhonenumberProviderEnum = void 0;
var VoiceRoutePhonenumberProviderEnum;
(function (VoiceRoutePhonenumberProviderEnum) {
    VoiceRoutePhonenumberProviderEnum["CONNECTEL"] = "CONNECTEL";
    VoiceRoutePhonenumberProviderEnum["VOXBONE"] = "VOXBONE";
    VoiceRoutePhonenumberProviderEnum["THIRD_PARTY"] = "THIRD_PARTY";
})(VoiceRoutePhonenumberProviderEnum = exports.VoiceRoutePhonenumberProviderEnum || (exports.VoiceRoutePhonenumberProviderEnum = {}));
